"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrOnboardingQuerySchema = exports.hrOnboardingTaskWaiveSchema = exports.hrOnboardingTaskCompleteSchema = exports.hrOnboardingStartSchema = exports.hrOnboardingTaskStatusEnum = exports.hrOnboardingTaskKeyEnum = exports.hrOnboardingStatusEnum = void 0;
const zod_1 = require("zod");
/**
 * HR PHASE 3 — onboarding. Starts from an ACCEPTED candidate. Does NOT
 * create the Employee/User row — `EMPLOYEE_CREATED` is completed by linking
 * the Employee HR already created through the existing employee-master
 * screen, via `employeeId`.
 */
exports.hrOnboardingStatusEnum = zod_1.z.enum(['IN_PROGRESS', 'COMPLETED', 'CANCELLED']);
exports.hrOnboardingTaskKeyEnum = zod_1.z.enum([
    'IDENTITY_DOCUMENT', 'ADDRESS_PROOF', 'EDUCATION_CERTIFICATES', 'EXPERIENCE_CERTIFICATES',
    'BACKGROUND_VERIFICATION', 'MEDICAL_FITNESS', 'CREDENTIAL_VERIFICATION', 'BANK_DETAILS',
    'STATUTORY_DETAILS', 'PHOTOGRAPH', 'EMPLOYEE_CREATED', 'ID_CARD', 'ACCESS_CARD',
    'SYSTEM_ACCOUNT', 'ORIENTATION', 'MANDATORY_TRAINING',
]);
exports.hrOnboardingTaskStatusEnum = zod_1.z.enum(['PENDING', 'COMPLETED', 'WAIVED']);
exports.hrOnboardingStartSchema = zod_1.z.object({
    candidateId: zod_1.z.string().uuid(),
});
/** `employeeId` is required (and validated server-side) only for the EMPLOYEE_CREATED task. */
exports.hrOnboardingTaskCompleteSchema = zod_1.z.object({
    employeeId: zod_1.z.string().uuid().optional(),
    notes: zod_1.z.string().trim().max(2000).optional(),
});
exports.hrOnboardingTaskWaiveSchema = zod_1.z.object({
    notes: zod_1.z.string().trim().min(3).max(2000),
});
exports.hrOnboardingQuerySchema = zod_1.z.object({
    status: exports.hrOnboardingStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).default(50),
});
//# sourceMappingURL=hr-onboarding.schema.js.map